import { computed, get } from '@ember/object';

export default function notEqualToProperty(dependentKey, targetKey) {
  return computed(dependentKey, targetKey, function () {
    return get(this, dependentKey) !== get(this, targetKey);
  });
}
